var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error center middle-column"},[_c('h3',[_vm._v("页面错误,重新登录")]),_c('button',{on:{"click":_vm.returnToLogin}},[_vm._v("返回")])])
}
var staticRenderFns = []

export { render, staticRenderFns }